<template>
  <div>
    <!--  -->
    <div class="d-flex mt-3" style="align-items:center;">
      <div style="flex-grow:1;" class="pl-2">
        <p class="" style="">
          Click on any column header to sort on that column. Click again to
          reverse order.
        </p>
      </div>
      <div class="form-group form-inline pr-2">
        <span class="mr-1">Show </span
        ><select
          v-model="PageSize"
          :disabled="Loading === true"
          class="form-control"
          ><option :value="10">10</option
          ><option :value="15">15</option
          ><option :value="20">20</option
          ><option :value="25">25</option
          ><option :value="50">50</option
          ><option :value="100">100</option
          ><option :value="200">200</option
          ><option :value="500">500</option
          ><option :value="1000">1000</option></select
        ><span class="ml-1"> entries</span>
      </div>
    </div>

    <!-- Table -->
    <table class="table table-striped table-hover border rounded">
      <thead>
        <tr>
          <th
            style="width: 10%; cursor: pointer;"
            @click="setSortFieldAndSortOrder('ID')"
          >
            <span>Id</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
          </th>
          <th
            style="width: 15%; cursor: pointer;"
            @click="setSortFieldAndSortOrder('FIRSTNAME')"
          >
            <span>Firstname</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
          </th>
          <th
            style="width: 15%; cursor: pointer;"
            @click="setSortFieldAndSortOrder('LASTNAME')"
          >
            <span>Lastname</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
          </th>
          <th
            style="width: 40%; cursor: pointer;"
            @click="setSortFieldAndSortOrder('EMAIL')"
          >
            <span>Email</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
          </th>
          <th
            style="width: 20%; cursor: pointer;"
            @click="setSortFieldAndSortOrder('USERNAME')"
          >
            <span>Username</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
          </th>
        </tr>
      </thead>

      <tr v-if="Loading === true">
        <td colspan="5">
          <a-spin class="d-block" />
        </td>
      </tr>
      <tbody v-else>
        <template v-for="(User, idx) in generalLookupUsersData.Result">
          <tr :key="User.id">
            <td>
              <div class="d-flex">
                <span @click="showMoreData(idx)" class="text-expand"
                  ><em
                    :style="[
                      idx === ShowMoreDataIndex
                        ? { color: 'red' }
                        : { color: '#28a745' },
                    ]"
                    :class="
                      idx === ShowMoreDataIndex
                        ? 'fa-solid fa-circle-minus pr-1'
                        : 'fa-solid fa-circle-plus pr-1'
                    "
                  ></em
                ></span>
                <p>{{ User.id }}</p>
              </div>
            </td>
            <td>{{ User.firstName }}</td>
            <td>{{ User.lastName }}</td>
            <td>{{ User.email }}</td>
            <td>
              <router-link
                :to="{ name: 'DivvyAdminUsersEditUser', params: { id: User.id } }"
              >
              {{ User.userName }}
              </router-link>
            </td>
          </tr>
          <tr :key="User.idx" v-show="idx === ShowMoreDataIndex">
            <td colspan="5">
              <ul style="list-style-type: none;">
                <li>
                  <span style="font-weight: bold;">Password: </span>
                  <span>{{ User.password }}</span>
                </li>
                <li>
                  <span style="font-weight: bold;">Points: </span>
                  <span>{{ User.points }}</span>
                </li>
                <li>
                  <span style="font-weight: bold;">Client: </span>
                  <router-link :to="{ name: 'Users' }">
                    {{ User.clientname }}
                  </router-link>
                </li>
                <li>
                  <span style="font-weight: bold;">Active: </span>
                  <span>{{ User.locked ? "Yes" : "No" }}</span>
                </li>
              </ul>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <!-- page Number -->
    <div class="d-flex mb-2" v-if="Loading === false">
      <div style="flex-grow: 1;" class="pl-2">
        <p>
          Showing {{ (PageNumber - 1) * PageSize + 1 }} to
          {{ UpperLimit }}
          of {{ TotalRecords }} entries
        </p>
      </div>
      <div class="pr-2">
        <Pagination
          :data="generalLookupUsersData.Result"
          :totalPages="Math.ceil(TotalRecords / PageSize)"
          :total="TotalRecords"
          :perPage="PageSize"
          :currentPage="PageNumber"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
    <!-- page Number -->
  </div>
</template>

<script>
import Pagination from "../../../../components/Pagination.vue";

export default {
  name: "GeneralLookupResultTable",
  data() {
    return {
      Loading: false,
      PageSize: 10,
      TotalRecords: 0,
      SortField: "",
      SortOrder: "",
      ShowMoreDataIndex: null,
    };
  },
  components: {
    Pagination,
  },
  watch: {
    PageSize() {
      // let SearchTerm = this.SearchTerm;
      // this.$store.commit("generalLookup/SET_SEARCH_TERM", "");
      this.updateData();
      // this.$store.commit("generalLookup/SET_SEARCH_TERM", SearchTerm);
    },
  },
  computed: {
    SearchTerm() {
      return this.$store.getters["generalLookup/searchTerm"];
    },
    generalLookupUsersData() {
      return this.$store.getters["generalLookup/generalLookupUsersData"];
    },
    UpperLimit() {
      return this.TotalRecords < this.PageNumber * this.PageSize
        ? this.TotalRecords
        : this.PageNumber * this.PageSize;
    },
    PageNumber() {
      return this.$store.getters["generalLookup/pageNumber"];
    },
  },
  methods: {
    onPageChange(page) {
      console.log("page changed", page);
      this.$store.commit("generalLookup/SET_PAGE_NUMBER", page);
      try {
        this.updateData();
      } catch (error) {
        console.log(error);
      }
      window.scrollTo(0, 0);
    },
    showMoreData(idx) {
      if (this.ShowMoreDataIndex === idx) {
        console.log(this.ShowMoreDataIndex, idx, 'if')
        this.ShowMoreDataIndex = null;
      } else {
        console.log(this.ShowMoreDataIndex, idx, 'else')
        this.ShowMoreDataIndex = idx;
      }
    },
    setSortFieldAndSortOrder(field) {
      if (this.SortField === field) {
        this.SortOrder = this.SortOrder === "ASC" ? "DESC" : "ASC";
      } else {
        this.SortField = field;
        this.SortOrder = "ASC";
      }
      this.updateData();
    },
    updateData() {
      this.Loading = true;
      this.$store
        .dispatch("generalLookup/getGeneralLookupUsers", {
          searchTerm: this.SearchTerm,
          pageNumber: this.PageNumber,
          pageSize: this.PageSize,
          sortField: this.SortField,
          sortOrder: this.SortOrder,
        })
        .then((data) => {
          this.Loading = false;
          this.PageSize = data.pageSize;
          this.SortField = data.sortField;
          this.SortOrder = data.sortOrder;
          this.TotalRecords = data.totalRecords;
        });
    },
  },
};
</script>

<style></style>
